// extracted by mini-css-extract-plugin
export default {"templates":"ProfilesPage_templates__sp6o-","logo":"ProfilesPage_logo__jUit4"};